import dayjs from 'dayjs'
import 'dayjs/locale/en'
import { useFormik } from 'formik'
import PrivateBaseLayout from 'general/components/eInvoiceComponents/BaseLayout/PrivateBaseLayout'
import Utils, { getParam, viewPopupSettingTool } from 'general/utils/Utils'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import * as Yup from 'yup'
import './style.scss'
// import invoiceReportApi from 'api/invoiceReportApi'
import invoiceReportApi from 'api/invoiceReportApi'
import ticketApi from 'api/ticketApi'
import toolApi from 'api/toolApi'
import { setAppSpinning } from 'app/appSlice'
import customProtocolCheck from 'custom-protocol-check'
import ModalChooseAdjustTicketToCreateReport from 'features/Ticket/components/ModalChooseAdjustTicketToCreateReport'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import {
  ACTION_TYPE,
  MAX_WAIT_SIGN_INVOICE,
} from 'general/constants/AppConstants'
import InvoiceReportHelper from 'general/helpers/InvoiceReportHelper'
import ToastHelper from 'general/helpers/ToastHelper'
import wsHelperInstance from 'general/helpers/WebSocketHelper'
import Global from 'general/utils/Global'
import moment from 'moment'
import DatePicker from 'react-datepicker'

dayjs.locale('en')

const externalAction = ['preview', 'sign', 'preview_not_save']

function CreateTicketReport() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const { ticketId } = useParams()
  const [searchParams] = useSearchParams()
  const reportId = searchParams.get('reportId')
  const today = new Date()

  const { company } = useSelector((state) => state.system)

  const [ticket, setTicket] = useState()
  const [report, setReport] = useState()
  const [actionType, setActionType] = useState()
  const [showModalConfirmPreview, setShowModalConfirmPreview] = useState(false)
  const [showModalConfirmSign, setShowModalConfirmSign] = useState(false)
  const [
    showModalChooseAdjustTicketToCreateReport,
    setShowModalChooseAdjustTicketToCreateReport,
  ] = useState(false)
  const [selectedAdjustTicket, setSelectedAdjustTicket] = useState()

  const _reportType = useMemo(
    () => pathname?.split('/')?.at(4),
    [pathname],
  ) /* bien-ban-huy/bien-ban-dieu-chinh */

  const screenAction = useMemo(() => pathname?.split('/')?.at(5), [pathname])

  let reportType = useMemo(
    () =>
      _reportType == 'bien-ban-huy'
        ? 'CANCEL'
        : _reportType == 'bien-ban-dieu-chinh'
          ? 'ADJUST'
          : '',
    [_reportType],
  )

  const navigateEndPoint = useCallback((reportType) => {
    const listEndPoints = {
      'bien-ban-huy': 'huy-bo',
      'bien-ban-dieu-chinh': 'dieu-chinh',
      'bien-ban-thay-the': 'thay-the',
    }
    return listEndPoints[reportType]
  }, [])

  const oldActionType = useRef()

  useEffect(() => {
    const parts = pathname.split('/')
    if (parts.includes('them-moi')) {
      setActionType(ACTION_TYPE.CREATE)
    }
    if (parts.includes('cap-nhat')) {
      setActionType(ACTION_TYPE.UPDATE)
    }
  }, [pathname])

  useEffect(() => {
    fetchTicketData(ticketId)
  }, [ticketId, pathname])

  useEffect(() => {
    if (!ticket) return

    let report =
      ticket.Report ||
      ticket.AllReports?.find(({ reportId: _reportId, invoiceId }) =>
        actionType == ACTION_TYPE.CREATE ? !invoiceId : _reportId == reportId,
      )
    setReport(report)

    if (reportType == 'ADJUST') {
      setSelectedAdjustTicket(
        ticket.TicketRelated?.find(
          ({ ticketId: _ticketId }) => _ticketId == report?.ticketId,
        ),
      )
    }
  }, [actionType, reportId, reportType, ticket, pathname])

  useEffect(() => {
    if (!ticket) return

    let ticketReportType =
      report?.reportType || ticket.AllReports?.at(-1)?.reportType
    if (ticketReportType && ticketReportType != reportType) {
      ToastHelper.showError(
        `Không thể lập biên bản ${InvoiceReportHelper.reportTypeToVnese(
          reportType,
        )} khi hóa đơn đã có biên bản ${InvoiceReportHelper.reportTypeToVnese(
          ticketReportType,
        )}`,
      )
      navigate('/hoa-don-dau-ra/tem-ve/ve-dien-tu/ve-da-xuat')
    }

    if (!report && screenAction != 'them-moi') {
      navigate(
        `/hoa-don-dau-ra/tem-ve/ve-dien-tu/${_reportType}/them-moi/${ticketId}`,
      )
    }

    if (report?.reportStatus == 1 && screenAction != 'cap-nhat') {
      navigate(
        `/hoa-don-dau-ra/tem-ve/ve-dien-tu/${_reportType}/cap-nhat/${ticketId}?reportId=${report.reportId}`,
      )
    }

    if (
      report?.reportStatus &&
      ![1].includes(report.reportStatus) &&
      screenAction != 'xem'
    ) {
      navigate(
        `/hoa-don-dau-ra/tem-ve/ve-dien-tu/${_reportType}/xem/${ticketId}?reportId=${report.reportId}`,
      )
    }
  }, [report])

  // const userFunction = useSelector(state => state?.function?.userFunctions)
  // const listFunction = useSelector(state => state?.function?.listFunctions)

  const validationSchema = Yup.object().shape({
    // customerTaxCode: Yup.string().matches(mstRegex, 'Mã số thuế không hợp lệ'),
    // .required(t("Required")),
  })

  const fetchTicketData = async (id) => {
    try {
      dispatch(setAppSpinning(true))
      const res = await ticketApi.findById(id)
      if (res?.result === 'success') {
        setTicket(res?.data)
      } else {
        ToastHelper.showError('Không tìm thấy dữ liệu')
      }
    } catch (err) {
      console.log(err)
      ToastHelper.showError('Có lỗi khi tìm dữ liệu')
    } finally {
      dispatch(setAppSpinning(false))
    }
  }

  const formik = useFormik({
    initialValues: {
      no: report?.no ?? '',
      date: Utils.formatDate(today),
      sellerName: report?.sellerName ?? company?.companyName ?? '',
      sellerTaxCode: report?.sellerTaxCode ?? company?.taxCode ?? '',
      sellerFullAddress:
        report?.sellerFullAddress ?? company?.businessPermitAddress ?? '',
      sellerPhone: report?.sellerPhone ?? company?.companyPhone ?? '',
      sellerContactPersonName:
        report?.sellerContactPersonName ?? company?.contactPersonName ?? '',
      sellerContactPersonPosition:
        report?.sellerContactPersonPosition ??
        company?.contactPersonPosition ??
        '',

      customerName: report?.customerName ?? ticket?.customerCompanyName ?? '',
      customerTaxCode: report?.customerTaxCode ?? ticket?.customerTaxCode ?? '',
      customerFullAddress:
        report?.customerFullAddress ?? ticket?.customerFullAddress ?? '',
      customerPhone: report?.customerPhone ?? ticket?.customerPhone ?? '',
      customerContactPersonName:
        report?.customerContactPersonName ?? ticket?.customerName ?? '',
      customerContactPersonPosition:
        report?.customerContactPersonPosition ?? '',
      reason: report?.reason ?? '',
      ticketId: ticketId ?? '',
      reportId: report?.reportId ?? '',
    },
    validationSchema,
    onSubmit: async (values) => {
      let status = true
      if (!formik.values?.reason) {
        status = false
        ToastHelper.showError('Chưa nhập lý do')
      }
      if (!formik.values?.sellerPhone) {
        status = false
        ToastHelper.showError('Chưa nhập số đại điện thoại bên mua')
      }
      if (!formik.values?.sellerContactPersonName) {
        status = false
        ToastHelper.showError('Chưa nhập dại diện bên mua')
      }
      if (!formik.values?.no) {
        status = false
        ToastHelper.showError('Chưa nhập số biên bản')
      }
      if (!status) return
      try {
        let res
        dispatch(setAppSpinning(true))

        if (!reportType) {
          ToastHelper.showError('reportType không hợp lệ')
          return
        }

        let params = { ...values, reportType, invoiceType: 'TICKET' }
        if (reportType === 'ADJUST') {
          params.originTicketId = params.ticketId
          // params.ticketId = selectedAdjustTicket?.ticketId
        }
        switch (actionType) {
          case ACTION_TYPE.CREATE:
            if (reportType == 'ADJUST') {
              res = await invoiceReportApi.createAdjustReport({ ...params })
            } else {
              res = await invoiceReportApi.create({ ...params })
            }
            navigate(`/hoa-don-dau-ra/tem-ve/xu-ly-ve/dieu-chinh`)
            dispatch(setAppSpinning(false))
            break
          case ACTION_TYPE.UPDATE:
            if (reportType == 'ADJUST') {
              res = await invoiceReportApi.updateAdjustReport({ ...params })
            } else {
              res = await invoiceReportApi.update({ ...params })
            }
            dispatch(setAppSpinning(false))
            break
          case 'preview': {
            setActionType(oldActionType.current)

            if (oldActionType.current == ACTION_TYPE.CREATE) {
              if (reportType == 'ADJUST') {
                res = await invoiceReportApi.createAdjustReport({ ...params })
              } else {
                res = await invoiceReportApi.create({ ...params })
              }
            } else if (oldActionType.current == ACTION_TYPE.UPDATE) {
              if (reportType == 'ADJUST') {
                res = await invoiceReportApi.updateAdjustReport({ ...params })
              } else {
                res = await invoiceReportApi.update({ ...params })
              }
            }
            ToastHelper.showSuccess('Lưu biên bản thành công')
            setShowModalConfirmPreview(false)

            res = await invoiceReportApi.preview({
              reportId: values.reportId || res.data?.reportId,
              reportType,
              invoiceType: 'TICKET',
            })
            dispatch(setAppSpinning(false))
            let newFile = new File(
              [res],
              `Biên bản ${InvoiceReportHelper.reportTypeToVnese(
                reportType,
              )}.pdf`,
              {
                type: 'application/pdf',
              },
            )
            var fileURL = URL.createObjectURL(newFile)
            window.open(fileURL, '_blank')

            return
          }
          case 'preview_not_save': {
            setActionType(oldActionType.current)
            res = await invoiceReportApi.preview({
              reportId: values.reportId,
              reportType,
              invoiceType: 'TICKET',
            })
            dispatch(setAppSpinning(false))

            let _newFile = new File(
              [res],
              `Biên bản ${InvoiceReportHelper.reportTypeToVnese(
                reportType,
              )}.pdf`,
              {
                type: 'application/pdf',
              },
            )
            var _fileURL = URL.createObjectURL(_newFile)
            window.open(_fileURL, '_blank')

            return
          }
          case 'sign':
            setActionType(oldActionType.current)
            if (oldActionType.current == ACTION_TYPE.CREATE) {
              if (reportType == 'ADJUST') {
                res = await invoiceReportApi.createAdjustReport({ ...params })
              } else {
                res = await invoiceReportApi.create({ ...params })
              }
            } else if (oldActionType.current == ACTION_TYPE.UPDATE) {
              if (reportType == 'ADJUST') {
                res = await invoiceReportApi.updateAdjustReport({ ...params })
              } else {
                res = await invoiceReportApi.update({ ...params })
              }
            }
            if (res?.result === 'success') {
              ToastHelper.showSuccess('Lưu biên bản thành công')
              setShowModalConfirmSign(false)

              values.reportId = values.reportId || res.data?.reportId

              if (company?.activeSigningMethod == 'HSM') {
                await invoiceReportApi.hsmReportSign({
                  reportId: values.reportId,
                })
                dispatch(setAppSpinning(false))
                ToastHelper.showSuccess(
                  `Ký biên bản ${InvoiceReportHelper.reportTypeToVnese(
                    reportType,
                  )} thành công`,
                )

                navigate(
                  `/hoa-don-dau-ra/tem-ve/ve-dien-tu/${_reportType}/xem/${ticketId}?reportId=${values.reportId}`,
                )
              } else {
                const { url } = await toolApi.genToolUrl({
                  param2: 'signReport',
                  param3: values.reportId,
                })
                if (url) {
                  let notInstalledCb = () => {
                    // alert('Chua cai tool!')
                    viewPopupSettingTool()
                  }

                  customProtocolCheck(
                    url,
                    notInstalledCb,
                    () => {
                      Utils.openInCurrentTab(url)
                    },
                    2500,
                  )

                  if (reportType == 'CANCEL') {
                    wsHelperInstance.onExecutingSignCancellationReport(
                      values.reportId,
                      url
                        .replace(process.env.REACT_APP_BASE_URL_SCHEMA, '')
                        .split(',')
                        ?.at(0),
                    )
                  } else {
                    wsHelperInstance.onExecutingSignAdjustReport(
                      values.reportId,
                      url
                        .replace(process.env.REACT_APP_BASE_URL_SCHEMA, '')
                        .split(',')
                        ?.at(0),
                    )
                  }

                  Global.gExecutingSignInvoiceReportTimeOut = setTimeout(() => {
                    dispatch(setAppSpinning(false))
                  }, MAX_WAIT_SIGN_INVOICE)
                }
              }
            } else {
              ToastHelper.showError('Lưu biên bản thất bại')
            }

            return
          default:
            return
        }

        if (res) {
          if (res.result === 'success') {
            ToastHelper.showSuccess('Lưu biên bản thành công')
          } else {
            ToastHelper.showError('Lưu biên bản thất bại')
          }
        }
      } catch (err) {
        console.log(err)
        dispatch(setAppSpinning(false))
        // if (actionType == 'preview') return
        // ToastHelper.showError('Lưu biên bản thất bại')
      }
    },
    enableReinitialize: true,
    validateOnChange: false,
  })

  const onChangeCancellationData = (fieldName, value) => {
    formik.setFieldValue(`${fieldName}`, value)
  }

  const handlePreparePrintCancellationReport = () => {
    // if (!report || report?.reportStatus == 1) {
    if (!getParam('reportId')) {
      setShowModalConfirmPreview(true)
    } else {
      if (!externalAction.includes(actionType)) {
        oldActionType.current = actionType
      }
      setActionType('preview_not_save')
      formik.handleSubmit()
    }
  }

  const handlePrintCancellationReport = () => {
    if (!externalAction.includes(actionType)) {
      oldActionType.current = actionType
    }
    setActionType('preview')
    formik.handleSubmit()
  }

  const handleSignCancellationReport = () => {
    if (!externalAction.includes(actionType)) {
      oldActionType.current = actionType
    }
    setActionType('sign')
    formik.handleSubmit()
  }

  return (
    <div className="CreateTicketReport">
      <PrivateBaseLayout nonPadding nonPageUpBtn>
        <>
          <div className="ticket-report-container mb-5">
            <div className="ticket-report-paper mx-auto">
              <div className="d-flex flex-column justify-content-center">
                <div className="text-center pt-5">
                  <div
                    className="text-uppercase font-sfpro-bold"
                    style={{ fontSize: '20px', fontWeight: '400' }}
                  >
                    CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                  </div>

                  <div
                    className="font-sfpro-bold"
                    style={{ fontSize: '16px', fontWeight: '400' }}
                  >
                    Độc lập - Tự do - Hạnh phúc
                  </div>
                  <div
                    className="font-sfpro-bold"
                    style={{
                      fontSize: '20px',
                      fontWeight: '700',
                      marginTop: '30px',
                    }}
                  >
                    {`BIÊN BẢN ${InvoiceReportHelper.reportTypeToVnese(
                      reportType,
                    )?.toUpperCase()} VÉ`}
                  </div>
                </div>
              </div>

              <div
                className="d-flex align-items-end justify-content-center"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="ticket-report-label">
                  Số biên bản:
                  <span className="ml-1" style={{ color: 'red' }}>
                    *
                  </span>
                </div>

                <div>
                  <input
                    type="text"
                    className="form-control input-dot"
                    readOnly={screenAction == 'xem'}
                    value={formik.values?.no}
                    onChange={(e) =>
                      onChangeCancellationData('no', e.target.value)
                    }
                    required
                  />
                </div>
              </div>

              <div
                className=" mt-5 "
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">
                  - Căn cứ Nghị định 123/2020/NĐ-CP ngày 19/10/2020 của Chính
                  phủ quy định về hóa đơn, chứng từ.
                </div>
                <div className="invoice-report-label">
                  - Căn cứ Nghị định 70/2025/NĐ-CP ngày 20/03/2025 của Chính phủ
                  sửa đổi, bổ sung một số điều của Nghị đinh 123/2020/NĐ-CP ngày
                  19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ.
                </div>{' '}
                <div className="invoice-report-label">
                  - Căn cứ Thông tư 32/2025/TT-BTC ngày 31/05/2025 của Bộ Tài
                  chính hướng dẫn thực hiện Nghị định số 123/2020/NĐ-CP ngày
                  19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ, Nghị
                  định số 70/NĐ-CP/2025 ngày 20/03/2025 sửa đổi, bổ sung một số
                  điều Nghị định số 123/2020/NĐ-CP.
                </div>{' '}
                <div className="invoice-report-label">
                  - Căn cứ vào thỏa thuận giữa các bên.
                </div>
              </div>

              <div
                className="d-flex align-items-end justify-content-center"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <DatePicker
                  className="d-flex justify-content-center"
                  dateFormat="dd/MM/yyyy"
                  maxDate={new Date()}
                  customInput={
                    <div className="m-auto">
                      <span className="ticket-date">
                        Hôm nay, ngày{' '}
                        {moment(formik.values.date, 'YYYY-MM-DD').date()} tháng{' '}
                        {moment(formik.values.date, 'YYYY-MM-DD').month() + 1}{' '}
                        năm {moment(formik.values.date, 'YYYY-MM-DD').year()}{' '}
                        chúng tôi gồm có:
                      </span>
                    </div>
                  }
                  // showIcon={true}
                  todayButton={<button>Hôm nay</button>}
                  readOnly={screenAction == 'xem'}
                  // selected={new Date(registrationDate)}
                  onChange={(date) => {
                    const newDate = dayjs(date).format('YYYY-MM-DD HH:mm:ss')
                    formik.setFieldValue('date', newDate)

                    // formik.setFieldValue(
                    //   'date',
                    //   dayjs(
                    //     date,
                    //     'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (Indochina Time)',
                    //   ).format('YYYY-MM-DD HH:mm:ss'),
                    // )
                    // changeRegistrationProperty(
                    //   dayjs(
                    //     date,
                    //     'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (Indochina Time)',
                    //   ).format('YYYY-MM-DD HH:mm:ss'),
                    // );
                  }}
                />
                {/* <div className="ticket-report-label">
                  Hôm nay, ngày 06 tháng 9 năm 2023 chúng tôi gồm có:
                </div> */}
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="ticket-report-label-bold">
                  Bên A (Bên bán):{' '}
                </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  {formik?.values?.sellerName}
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="ticket-report-label">Địa chỉ: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  {formik.values?.sellerFullAddress}
                </div>
              </div>

              <div className="d-flex flex-row justify-content-between">
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="ticket-report-label">Mã số thuế: </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    {formik.values?.sellerTaxCode}
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="ticket-report-label">
                    Số điện thoại <span style={{ color: 'red' }}>*</span>:{' '}
                  </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      style={{ flex: 'auto' }}
                      value={formik.values?.sellerPhone}
                      readOnly={screenAction == 'xem'}
                      onChange={(e) =>
                        onChangeCancellationData('sellerPhone', e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex flex-row justify-content-between">
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="ticket-report-label">
                    Đại diện <span style={{ color: 'red' }}>*</span>:{' '}
                  </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      style={{ flex: 'auto' }}
                      value={formik.values?.sellerContactPersonName}
                      readOnly={screenAction == 'xem'}
                      onChange={(e) =>
                        onChangeCancellationData(
                          'sellerContactPersonName',
                          e.target.value,
                        )
                      }
                    />
                  </div>
                </div>

                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="ticket-report-label">Chức vụ: </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      style={{ flex: 'auto' }}
                      value={formik.values?.sellerContactPersonPosition}
                      readOnly={screenAction == 'xem'}
                      onChange={(e) =>
                        onChangeCancellationData(
                          'sellerContactPersonPosition',
                          e.target.value,
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="ticket-report-label-bold">
                  Bên B (Bên mua):{' '}
                </div>
                <div className="flex-grow-1" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot"
                    style={{ flex: 'auto' }}
                    value={formik.values?.customerName}
                    readOnly={screenAction == 'xem'}
                    onChange={(e) =>
                      onChangeCancellationData('customerName', e.target.value)
                    }
                  />
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="ticket-report-label">Địa chỉ: </div>
                <div className="flex-grow-1" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot w-100"
                    style={{ flex: 'auto' }}
                    value={formik.values?.customerFullAddress}
                    readOnly={screenAction == 'xem'}
                    onChange={(e) =>
                      onChangeCancellationData(
                        'customerFullAddress',
                        e.target.value,
                      )
                    }
                  />
                </div>
              </div>

              <div className="d-flex flex-row justify-content-between">
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="ticket-report-label">Mã số thuế: </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      style={{ flex: 'auto' }}
                      value={formik.values?.customerTaxCode}
                      readOnly={screenAction == 'xem'}
                      onChange={(e) =>
                        onChangeCancellationData(
                          'customerTaxCode',
                          e.target.value,
                        )
                      }
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="ticket-report-label">Số điện thoại: </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      style={{ flex: 'auto' }}
                      value={formik.values?.customerPhone}
                      readOnly={screenAction == 'xem'}
                      onChange={(e) =>
                        onChangeCancellationData(
                          'customerPhone',
                          e.target.value,
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex flex-row justify-content-between">
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="ticket-report-label">Đại diện: </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      style={{ flex: 'auto' }}
                      value={formik.values?.customerContactPersonName}
                      readOnly={screenAction == 'xem'}
                      onChange={(e) =>
                        onChangeCancellationData(
                          'customerContactPersonName',
                          e.target.value,
                        )
                      }
                    />
                  </div>
                </div>

                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="ticket-report-label">Chức vụ: </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      style={{ flex: 'auto' }}
                      value={formik.values?.customerContactPersonPosition}
                      readOnly={screenAction == 'xem'}
                      onChange={(e) =>
                        onChangeCancellationData(
                          'customerContactPersonPosition',
                          e.target.value,
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="ticket-report-label">
                  {`Hai bên thống nhất lập biên bản này để ${InvoiceReportHelper.reportTypeToVnese(
                    reportType,
                  )} vé theo quy
                  định.`}
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="ticket-report-label">{`Vé bị ${InvoiceReportHelper.reportTypeToVnese(
                  reportType,
                )}: `}</div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  <div className="ticket-report-label">
                    Ký hiệu {ticket?.serial}, số {ticket?.no}, ngày{' '}
                    {Utils.shortenDate(ticket?.dateRelease)}
                  </div>
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="ticket-report-label">
                  {`Lý do ${InvoiceReportHelper.reportTypeToVnese(
                    reportType,
                  )}: `}
                  <span className="ml-1" style={{ color: 'red' }}>
                    *
                  </span>
                </div>
                <div className="flex-grow-1">
                  <input
                    type="text"
                    className="form-control input-dot"
                    value={formik.values?.reason}
                    readOnly={screenAction == 'xem'}
                    onChange={(e) =>
                      onChangeCancellationData('reason', e.target.value)
                    }
                  />
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                Chúng tôi xin cam đoan các thông tin khai ở trên là hoàn toàn
                chính xác. Nếu có bất kỳ sai sót nào chúng tôi xin chịu trách
                nhiệm trước pháp luật.
              </div>

              <div className="d-flex flex-row justify-content-between align-items-start px-30">
                <div className="text-center">
                  <div>
                    <div className="font-sfpro-bold">Đại diện bên A </div>
                    <div className="mb-4">(Chữ ký số, chữ ký điện)</div>
                    <button
                      className="btn btn-light d-inline-flex align-items-center"
                      style={{ color: '#041847', backgroundColor: '#e4e6eb' }}
                      onClick={() => {
                        let status = true

                        if (!formik.values?.reason) {
                          status = false
                          ToastHelper.showError('Chưa nhập lý do')
                        }
                        if (!formik.values?.sellerPhone) {
                          status = false
                          ToastHelper.showError(
                            'Chưa nhập số đại điện thoại bên mua',
                          )
                        }
                        if (!formik.values?.sellerContactPersonName) {
                          status = false
                          ToastHelper.showError('Chưa nhập dại diện bên mua')
                        }
                        if (!formik.values?.no) {
                          status = false
                          ToastHelper.showError('Chưa nhập số biên bản')
                        }

                        if (status) setShowModalConfirmSign(true)
                      }}
                      disabled={report && report?.reportStatus != 1}
                    >
                      <i
                        className="fal fa-file-contract"
                        style={{ color: '#041847' }}
                      ></i>
                      Ký điện tử
                    </button>
                  </div>
                </div>

                <div className="text-center">
                  <div>
                    <div className="font-sfpro-bold">Đại diện bên B</div>
                    <div className="mb-4">(Chữ ký số, chữ ký điện)</div>
                    {/* <button
                      className="btn btn-light d-inline-flex align-items-center"
                      style={{ color: '#041847', backgroundColor: '#e4e6eb' }}
                    >
                      <i className="fal fa-file-contract" style={{ color: '#041847' }}></i>Ký điện
                      tử
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ticket-report-footer d-flex flex-row justify-content-between align-items-center px-6 py-2 border-top border-secondary">
            <div className="d-flex flex-row">
              <button
                className="btn btn-secondary mr-2"
                onClick={() =>
                  navigate(
                    `/hoa-don-dau-ra/tem-ve/xu-ly-ve/${navigateEndPoint(_reportType)}`,
                  )
                }
              >
                <i className="fa-sharp fa-regular fa-arrow-left"></i>Quay lại
              </button>

              {/* {reportType == 'ADJUST' && !selectedAdjustTicket && (
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    setShowModalChooseAdjustTicketToCreateReport(true)
                  }
                >
                  Lập biên bản điều chỉnh
                </button>
              )} */}

              {reportType == 'ADJUST' && selectedAdjustTicket && (
                <a className="d-flex flex-row algin-item-center mt-5">
                  <span className="mr-1">Vé điều chỉnh</span>
                  <span className="mr-1">{` ${selectedAdjustTicket?.serial} - ${selectedAdjustTicket?.no}`}</span>
                  <i
                    className="fa-regular fa-xmark mb-1"
                    style={{ color: '#212529', fontSize: '1.5em' }}
                    title="Xóa vé điều chỉnh"
                    onClick={() => setSelectedAdjustTicket(null)}
                  ></i>
                </a>
              )}
            </div>

            <button
              className="btn btn-secondary"
              onClick={handlePreparePrintCancellationReport}
            >
              <i className="fa-regular fa-print"></i>In
            </button>

            <div className="d-flex flex-row">
              {screenAction != 'xem' && (
                <button
                  className="btn btn-primary d-flex flex-row align-items-center py-2 mr-2"
                  onClick={formik.handleSubmit}
                >
                  <i className="fa-regular fa-check"></i>Lưu
                </button>
              )}
              {screenAction != 'xem' && (
                <button
                  className="btn btn-primary d-flex flex-row align-items-center py-2"
                  onClick={handleSignCancellationReport}
                >
                  <i className="fa-regular fa-pen-to-square"></i>Lưu và ký
                </button>
              )}
            </div>
          </div>

          <ModalConfirm
            show={showModalConfirmPreview}
            setShow={setShowModalConfirmPreview}
            header="Xác nhận"
            content="Để thực hiện chức năng này, bạn cần lưu các thông tin trên biên bản. Bạn có muốn lưu không1?"
            handleConfirm={handlePrintCancellationReport}
          />

          <ModalConfirm
            show={showModalConfirmSign}
            setShow={setShowModalConfirmSign}
            header="Xác nhận"
            content={`Để thực hiện ký biên bản ${InvoiceReportHelper.reportTypeToVnese(
              reportType,
            )}, bạn cần lưu các thông tin trên biên bản. Bạn có muốn lưu không?`}
            handleConfirm={handleSignCancellationReport}
          />

          <ModalChooseAdjustTicketToCreateReport
            show={showModalChooseAdjustTicketToCreateReport}
            setShow={setShowModalChooseAdjustTicketToCreateReport}
            activeTicket={ticket}
            handleChooseAdjustTicket={(ticket) =>
              setSelectedAdjustTicket(ticket)
            }
          />
        </>
      </PrivateBaseLayout>
    </div>
  )
}

export default CreateTicketReport
